export default __webpack_public_path__ + "static/media/Course-Icons3.b4abd472.svg";